import React from "react";
import { UsedBy } from "../components";

export function UsedByContainer() {
  const UsedByObj = [
    {
      icon: "/images/icons/vector (17).png",
      title: "Offices",
    },
    {
      icon: "/images/icons/vector (18).png",
      title: "Schools",
    },
    {
      icon: "/images/icons/vector (19).png",
      title: "Residentials",
    },
    {
        icon: "/images/icons/vector (20).png",
        title: "Events",
      },
      {
        icon: "/images/icons/vector (21).png",
        title: "Coworking",
      },
  ];
  return (
    <UsedBy>
      {/* <UsedBy.SubHeading>How it works</UsedBy.SubHeading> */}
      <UsedBy.Heading>VMS is used by</UsedBy.Heading>
      <UsedBy.Line/>
      <UsedBy.Frame>
        {UsedByObj.map((item) => (
          <UsedBy.Pane>
          <UsedBy.InfoContainer>
              <UsedBy.Logo src={item.icon} />
            </UsedBy.InfoContainer>
            <UsedBy.Text>{item.title}</UsedBy.Text>
          </UsedBy.Pane>
        ))}
      </UsedBy.Frame>
    </UsedBy>
  );
}
